import { Button } from "@molecules";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  align-self: flex-start;
  margin-top: 10px;
`;
